// extracted by mini-css-extract-plugin
export var container = "about-module--container--1wKBA";
export var icon = "about-module--icon--2eLuZ";
export var linktoabout = "about-module--linktoabout--1bhap";